export default __webpack_public_path__ + "static/goal-welfare-e8934d3789c6f90d5cf6ef5ebcbd8342.jpg";